export default "__VITE_ASSET__BHzpmLnB__"